export default {
	data() {
    return {
      appName: 'Zelan',
      email: "saintridge40@gmail.com"
    }
  },
}